import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {livingConditionsToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext} from 'react-hook-form'
import {z} from 'zod'

const ProjectPatientLivingConditionSchema = ProjectFieldsSchema.pick({
    livingConditions: true
})
type ProjectPatientLivingConditionSchema = z.infer<typeof ProjectPatientLivingConditionSchema>

export const ProjectPatientLivingConditionField = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<ProjectPatientLivingConditionSchema>()
    const {field} = useController({control, name: 'livingConditions'})

    return (
        <InputSelect
            {...field}
            value={field.value ?? undefined}
            optionsMap={livingConditionsToLabel}
            onClear={() => field.onChange(null)}
            label={t('projects:life_conditions')}
        />
    )
}
